module.exports = __webpack_public_path__ + "static/media/0077_Small.3a5bb61c.jpg";